function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["aria-label"],
  _excluded2 = ["name", "size", "ariaLabel", "isInteractive"];
var _jsxFileName = "/home/runner/work/frontend/frontend/libs/ui-design-system/src/components/Atoms/Icon/Icon.tsx",
  _this = this;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import SvgIcon from '@mui/material/SvgIcon';
import MuiIconButton from '@mui/material/IconButton';
import * as icons from "../../../assets/icons";
import { jsx as _jsx } from "react/jsx-runtime";
export var IconButton = function IconButton(_ref) {
  var ariaLabel = _ref['aria-label'],
    rest = _objectWithoutProperties(_ref, _excluded);
  return _jsx(MuiIconButton, {
    "aria-label": ariaLabel || rest.name,
    sx: {
      padding: 0
    },
    children: _jsx(Icon, _objectSpread({
      isInteractive: true
    }, rest))
  });
};
var getSizes = function getSizes(params) {
  var sizes = {};
  if (params.h) sizes['height'] = params.h;
  if (params.w) sizes['width'] = params.w;
  return sizes;
};
export var Icon = function Icon(_ref2) {
  var name = _ref2.name,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 20 : _ref2$size,
    ariaLabel = _ref2.ariaLabel,
    isInteractive = _ref2.isInteractive,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return _jsx(SvgIcon, _objectSpread({
    "aria-label": ariaLabel,
    component: icons[name],
    "data-test": "icon-".concat(name),
    inheritViewBox: true,
    width: size,
    height: size,
    style: _objectSpread({
      fill: 'none',
      cursor: isInteractive ? 'pointer' : 'auto'
    }, getSizes(rest))
  }, rest));
};
//# sourceMappingURL=Icon.js.map